/* eslint-disable no-unreachable */
import PropTypes from 'prop-types'

import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer'
import LeadPartnerMarker from 'assets/images/marker-orange.png'
import PartnerMarker from 'assets/images/marker.png'

const MarkerCluster = props => {
  const { map, google, markers, onClusterClick, onMarkerClick, setRef, currentCluster } = props

  if (map && markers && currentCluster.current == null) {
    
    // 1. PERFORMANCE: Directly map markers instead of using cloneDeep
    const dots = markers.map(m => {
      const currentDot = new google.maps.Marker({
        position: { lat: m.location.lat, lng: m.location.lng },
        id: m.id,
        icon: {
          url: m.type === 'lead' ? LeadPartnerMarker : PartnerMarker
        }
      })
      
      currentDot.addListener('click', () => onMarkerClick({ entry: currentDot, marker: m }))
      return currentDot
    })

    // 2. LEGACY ICONS: Recreate the old imagePath logic using a custom renderer
    const renderer = {
      render: ({ count, position }) => {
        // Calculate the icon size tier based on marker count (matches old logic)
        let index = 1
        if (count >= 10) index = 2
        if (count >= 101) index = 3
        if (count >= 1001) index = 4
        if (count >= 10001) index = 5

        return new google.maps.Marker({
          position,
          label: {
            text: String(count),
            color: '#000000', // Kept black to match legacy m1-m5 icon text
            fontSize: '12px',
            fontWeight: 'bold'
          },
          icon: {
            url: `https://raw.githubusercontent.com/googlemaps/js-marker-clusterer/gh-pages/images/m${index}.png`
          },
          // Push clusters to the top layer above standard markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        })
      }
    }

    // 3. ALGORITHM: Use the heavily optimized SuperCluster algorithm (now standard)
    const algorithm = new SuperClusterAlgorithm({ 
      maxZoom: 11,
      radius: 95
    })

    // 4. INITIALIZATION: Single config object
    const clusterer = new MarkerClusterer({
      map,
      markers: dots,
      algorithm,
      renderer,
      onClusterClick: (event, cluster) => {
        // Overriding this automatically disables the default zoomOnClick behavior
        onClusterClick(cluster)
      }
    })

    setRef(clusterer)
  }
  
  return null
}

MarkerCluster.propTypes = {
  map: PropTypes.object,
  google: PropTypes.object,
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      location: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number
      })
    })
  ),
  onClusterClick: PropTypes.func,
  onMarkerClick: PropTypes.func,
  setRef: PropTypes.func,
  // React refs are objects with a 'current' property
  currentCluster: PropTypes.shape({
    current: PropTypes.any
  })
}

export default MarkerCluster